import React from "react";
import { useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { MenuFoldOutlined, MenuUnfoldOutlined } from "@ant-design/icons";

import "./navbar.scss";
import { useLayout } from "../../context/layoutContext";
import BurgerIcon from "../burger/BurgerIcon";

// Page titles for the top bar, keyed by the first path segment.
const PAGE_TITLES = {
  "": "Dashboard",
  analytics: "Analytics and Marketing Data",
  "search-analytics": "Search Analytics",
  "tramango-users": "Tramango Users",
  users: "Users",
  discount: "Discounts",
  staff: "Staff",
  finance: "Finance",
  revenue: "Revenue",
  flights: "Flights",
  insurance: "Insurance",
  advert: "Advertisement",
  packages: "Packages & Quick Trips",
  vault: "Tramango Vault",
  twofactor: "2 Factor Authentication",
  profile: "Profile",
  stats: "Stats",
  notifications: "Notifications",
  "system-health": "System Health",
  logs: "Logs",
  settings: "Settings",
};

const Navbar = () => {
  const { admin } = useSelector((state) => state.auth);
  const { isMobile, collapsed, mobileNavOpen, toggleSidebar } = useLayout();
  const { pathname } = useLocation();

  const title = PAGE_TITLES[pathname.split("/")[1] ?? ""] ?? "";
  const fullName = [admin?.lastName, admin?.firstName].filter(Boolean).join(" ");
  const initials = [admin?.firstName, admin?.lastName]
    .filter(Boolean)
    .map((name) => name[0])
    .join("")
    .toUpperCase();

  const toggleIcon = isMobile ? (
    <BurgerIcon open={mobileNavOpen} />
  ) : collapsed ? (
    <MenuUnfoldOutlined />
  ) : (
    <MenuFoldOutlined />
  );
  const toggleLabel = isMobile
    ? mobileNavOpen
      ? "Close navigation"
      : "Open navigation"
    : collapsed
    ? "Expand sidebar"
    : "Collapse sidebar";

  return (
    <header className="navbar">
      <div className="navbar__start">
        <button
          type="button"
          className="navbar__toggle"
          onClick={toggleSidebar}
          aria-label={toggleLabel}
          aria-expanded={isMobile ? mobileNavOpen : !collapsed}
          title={toggleLabel}
        >
          {toggleIcon}
        </button>
        {title && <h1 className="navbar__title">{title}</h1>}
      </div>

      {fullName && (
        <div className="navbar__user" title={fullName}>
          <span className="navbar__avatar" aria-hidden="true">
            {initials}
          </span>
          <span className="navbar__name">{fullName}</span>
        </div>
      )}
    </header>
  );
};

export default Navbar;
